import React from "react";
import {useVaultDispatch} from "../core/top/VaultContext";
import {User} from "../../shared/types/VaultTypes";
import {AT} from "../core/vault/ActionTypeConstants";
import CopyTable from "./data/CopyTable";
import OpsUser from "../core/vault/OpsUser.js";
import URLMake from "../../shared/URLMake.js";
import Link from "../core/view/Link.jsx";
import * as styles from "./styles/PageMailingList.css";
import AssetsUtil from "../core/util/AssetsUtil.js";

type PageConfirmEmailProps = {
	type:
		| "confirmation"
		| "confirmed"
		| "update"
		| "invalid"
		| "outdated"
		| "error";
	email?: string;
	user: User;
};
export const PageConfirmEmail = ({
	type,
	email,
	user,
}: PageConfirmEmailProps) => {
	const dispatch = useVaultDispatch();

	const startLogin = React.useCallback(() => {
		if (!dispatch) return;
		const prefill = email === "undefined" ? null : email;
		dispatch({
			type: AT.START_OFFICE_LOGIN,
			opts: {email: prefill || ""},
		});
	}, [dispatch, email]);

	const Copy = CopyTable.getConfirmEmailCopy(email);
	const message = Copy[type];
	let imgSrc =
		// @ts-ignore
		`${global.BASE_URL}assets/images/office/characters/happy-fiona-grok.svg`;

	let belowContent;
	if (type === "update" || type === "confirmed" || type === "invalid") {
		if (OpsUser.isLoggedIn(user)) {
			const to = OpsUser.getStaffedPurchaseID(user)
				? URLMake.forStaffProfile()
				: URLMake.forAccount("information");
			belowContent = (
				<Link to={to} className={styles.button}>
					Account
				</Link>
			);
		} else {
			belowContent = (
				<div className={styles.links}>
					<div onClick={startLogin} className={styles.button}>
						SIGN IN
					</div>
				</div>
			);
		}
	} else if (type === "confirmation") {
		belowContent = (
			<div className={styles.links}>
				<div onClick={startLogin} className={styles.button}>
					SIGN IN
				</div>
			</div>
		);
	} else {
		imgSrc = AssetsUtil.getGotProblems();
	}

	return (
		<div className={styles.main}>
			<img className={styles.image} src={imgSrc} />
			<div className={styles.message}>{message}</div>
			{belowContent}
		</div>
	);
};
